module.exports = __webpack_public_path__ + "img/jellyfish.0782ae1d.jpg";